/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Close_LabelInputs */



/**
* | output |
* | --- |
* | "Close Marker Import" |
*
* @param {Marker_Import_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_close_label = /** @type {((inputs?: Marker_Import_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer l'importation des marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schließen-Markierung importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi importazione marcatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть Маркер Импорт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar importación de marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭标记导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーのインポートを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर आयात बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar Importação de Marcador")
	return /** @type {LocalizedString} */ ("Close Marker Import")
});